module.exports = __webpack_public_path__ + "static/67import-9d7856736f6c584c95232fecce6b42c3.png";